import Swiper from 'swiper';
import { Controller, EffectFade } from 'swiper/modules';
import { debounce } from 'lodash';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import { AccessibilityHelper } from "../GlobalAssets/js/accessibilityHelper";

class IndustryDetailHero {
  constructor(component) {
    this.refs = {
      mobileImageSlider: '.js-mobile-images-slider',
      mobileImagesPrev: '.js-mobile-prev',
      mobileImagesNext: '.js-mobile-next',
      mobileImageCaptionSlider: '.js-mobile-image-caption-slider',
      desktopImageSlider: '.js-desktop-images-slider',
      desktopImagesPrev: '.js-desktop-prev',
      desktopImagesNext: '.js-desktop-next',
    };

    this.dom = {
      $mobileImagesSlider: document.querySelectorAll(this.refs.mobileImageSlider),
      $mobileImagesPrev: document.querySelector(this.refs.mobileImagesPrev),
      $mobileImagesNext: document.querySelector(this.refs.mobileImagesNext),
      $mobileImageCaptionSlider: document.querySelector(this.refs.mobileImageCaptionSlider),
      $desktopImageSlider: document.querySelector(this.refs.desktopImageSlider),
      $desktopImagesPrev: document.querySelector(this.refs.desktopImagesPrev),
      $desktopImagesNext: document.querySelector(this.refs.desktopImagesNext),
    };

    this.state = {
      mobileImagesSlider: null,
      mobileImageCaptionSlider: null,
      desktopImageSlider: null,
      accessibilityHelper: new AccessibilityHelper(),
      mobileSlideChangeDebounceHandler: null,
      desktopSlideChangeDebounceHandler: null,
    };

    this.init();

    this.mount();
  }

  init() {
    const { state } = this;
    state.mobileSlideChangeDebounceHandler = debounce((swiper) => {
      this.setViewableSlides(swiper);
      this.setViewableSlides(state.mobileImageCaptionSlider);
    }, 500);

    state.desktopSlideChangeDebounceHandler = debounce((swiper) => {
      this.setViewableSlides(swiper);
    }, 500);

    state.mobileImageCaptionSlider = new Swiper(this.refs.mobileImageCaptionSlider, {
      modules: [EffectFade],
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: false,
      loop: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      watchSlidesProgress: true,
      on: {
        afterInit: (swiper) => {
          swiper.loopFix();
        },
      },
    });

    // Initialize Swiper for mobile images slider
    state.mobileImagesSlider = new Swiper(this.refs.mobileImageSlider, {
      modules: [Controller],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      watchSlidesProgress: true,
      controller: {
        control: state.mobileImageCaptionSlider,
      },
      on: {
        afterInit: (swiper) => {
          swiper.loopFix();
        },
        slideChange: (swiper) => state.mobileSlideChangeDebounceHandler(swiper),
        slideChangeTransitionEnd: (swiper) => {
          swiper.loopFix();
          this.setViewableSlides(swiper);
          this.setViewableSlides(state.mobileImageCaptionSlider);
        },
      },
    });

    // Initialize Swiper for desktop images slider
    state.desktopImageSlider = new Swiper(this.refs.desktopImageSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      watchSlidesProgress: true,
      on: {
        afterInit: (swiper) => {
          swiper.loopFix();
        },
        slideChange: (swiper) => state.desktopSlideChangeDebounceHandler(swiper),
        slideChangeTransitionEnd: (swiper) => {
          swiper.loopFix();
          this.setViewableSlides(swiper);
        },
      },
    });

    // Set initial accessibility state for all sliders
    this.setViewableSlides(state.mobileImageCaptionSlider);
    this.setViewableSlides(state.mobileImagesSlider);
    this.setViewableSlides(state.desktopImageSlider);
  }

  mount() {
    const { dom, state } = this;

    if (dom.$mobileImagesPrev) {
      dom.$mobileImagesPrev.addEventListener('click', () => {
        this.state.mobileImagesSlider.slidePrev(1000);
      });
    }

    if (dom.$mobileImagesNext) {
      dom.$mobileImagesNext.addEventListener('click', () => {
        this.state.mobileImagesSlider.slideNext(1000);
      });
    }

    if (dom.$desktopImagesPrev) {
      dom.$desktopImagesPrev.addEventListener('click', () => {
        this.state.desktopImageSlider.slidePrev(1000);
      });
    }

    if (dom.$desktopImagesNext) {
      dom.$desktopImagesNext.addEventListener('click', () => {
        this.state.desktopImageSlider.slideNext(1000);
      });
    }
  }

  setViewableSlides({ slides }) {
    const { state } = this;

    slides.forEach((slide) => {
      const isVisible = slide.classList.contains('swiper-slide-fully-visible');
      state.accessibilityHelper.updateElementAccessibility(slide, isVisible);
      slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    });
  }
}

const $industryDetailHero = document.querySelector('.js-industry-detail-hero');
if ($industryDetailHero) new IndustryDetailHero($industryDetailHero);
